import { showConfirm, showNotification } from '@/main/utils/notifications';

import { httpRequest } from '#services/httpRequest';

import { localizeLocal } from '../../mixins/localization';

import {
	AUTH_SUCCESS, AUTH_LOGOUT, AUTH_ERROR, AUTH_AUTOLOGIN, SSO_STATE_UPDATE, SET_RESET_PASSWORD,
	SET_CHANGE_PASSWORD,USER_ACTIVE_NEW_SESSION,
} from '../actionTypes';

import { Auth, SSOState } from './state';
const channel = new BroadcastChannel('sessionEnd');

export const mutations = {
	[SSO_STATE_UPDATE](state: Auth, ssoState: SSOState) {
		state.ssoState = ssoState;
	},
	[AUTH_LOGOUT](state: Auth) {
		state.auth = false;
		httpRequest.removeAxiosTenantQuery();
		httpRequest.removeAxiosJwtQuery();
	},
	[AUTH_ERROR]: (state: Auth, { message, showError = true }: { message: string, showError: boolean }) => {
		state.error.add(message);
		const language = navigator.languages[0].split('-')[0];

		showError && showNotification({
			title: localizeLocal('LoginError', language as 'cs' | 'en'),
			message: localizeLocal('WrongUserOrPassword', language as 'cs' | 'en'),
			type: 'error',
			showClose: false,
		});
	},
	[USER_ACTIVE_NEW_SESSION]: (state: Auth, { message, showError = true }: { message: string, showError: boolean }) => {
		var language = localStorage.getItem("i18nextLng");
		if ((typeof language === "string" && language.length === 0) ||(language === null)) {
			language = navigator.languages[0].split('-')[0];
		}
		language = (language == 'tw' ? 'zh' : language);
		showConfirm({
			message: localizeLocal('UserActiveNewSession', language as 'cs' | 'zh' | 'en'),
			title: 'Notification',
			options: {
				type: 'info',
				confirmButtonText: 'Ok',
				showClose:false,
				showCancelButton:false,
				closeOnClickModal:false,
				callback: async (action: string) => {
					if (action === 'confirm') {
						sessionStorage.removeItem('newSessionDetected');
                    	try { channel.postMessage({ type: 'sessionEnd', time: Date.now() }); } catch (e) { /* channel closed */ }
						sessionStorage.setItem('loggedIn', 'false');
						httpRequest.removeAxiosJwtQuery();
						window.location.href = '/session-over';
					}
				},
			},
		});
	},
	[AUTH_SUCCESS]: (state: Auth) => {
		state.auth = true;
	},
	[AUTH_AUTOLOGIN]: (state: Auth, hash: string | null) => {
		state.dms3Hash = hash;
	},
	[SET_RESET_PASSWORD]: (state: Auth, reset: boolean) => {
		state.resetPassword = reset;
	},
	[SET_CHANGE_PASSWORD]: (state: Auth, reset: boolean) => {
		state.changePassword = reset;
	},
};

channel.onmessage = (e) => {
  if (e.data.type === 'sessionEnd'
    && sessionStorage.getItem('loggedIn') === 'true' && window.location.pathname !== '/session-over') {
    sessionStorage.setItem('loggedIn', 'false');
    httpRequest.removeAxiosJwtQuery();
	window.location.href = '/session-over';
  }
};
